<template>
  <div>
    <b-row>
      <b-col sm="4" style="padding-right: 0.1rem">
        <b-img class="upload_tn"
          v-if="!loaderror && cur_image_url && cur_image_type == 'image'"
          :src="cur_image_url"
          @error="img_onerror"
          fluid />
        <video class="upload_tn" controls
          style="max-width:100%"
          v-if="!loaderror && cur_image_url && cur_image_type == 'video'"
          :src="cur_image_url"
          @error="img_onerror"
          fluid />
        <audio class="upload_tn" controls
          style="max-width:100%"
          v-if="!loaderror && cur_image_url && cur_image_type == 'audio'"
          :src="cur_image_url"
          @error="img_onerror"
          fluid />
        <div class="upload_tn" v-if="!cur_image_url">{{msg_placeholder}}</div>
      </b-col>
      <b-col sm="5" style="padding: 0">
        <b-form-file class="upload_file" v-model="imageFile"> </b-form-file>
        <div class="upload_error" v-if="image_error">
          {{ image_error }}
        </div>
        <div class="upload_success" v-if="image_success">
          {{ image_success }}
        </div>
      </b-col>
      <b-col sm="3">
        <b-button
          class="upload_btn"
          size="sm"
          :disabled="!imageFile || imageUploadDisabled"
          variant="primary"
          @click="upload_image"
        >
          {{btn_label}}
        </b-button>
        <b-button
          class="upload_btn"
          size="sm"
          v-if="optional && value"
          variant="outline-danger"
          @click="upload_clear"
        >
          Clear
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vx_api from "../vuemix";

export default {
  name: "UploadImage",
  props: ["value", "mime", "evid", "types", "imgkind", "tnkind", "optional", "size", "placeholder","btnlab"],
  data() {
    return {
      imageFile: null,
      image_error: "",
      image_success: "",
      imageUploadDisabled: false,
      orig_url: "",
      orig_mime: "",
      cur_image_url: "",
      cur_image_type: "",
      loaderror: false,
      msg_placeholder: "No File",
      btn_label: "Upload",
    };
  },
  watch: {
    imageFile: function (to, from) {
      this.image_error = "";
      this.loaderror = false;
    },
    value: function(to,from) {
      this.orig_url = to;
      this.nocache_image_url(to, this.orig_mime);
    },
    mime: function(to,from) {
      this.orig_mime = to;
      this.nocache_image_url(this.orig_url,to);
    },
  },
  mounted() {
    this.orig_url = this.value;
    this.orig_mime = this.mime;
    this.loaderror = false;
    this.msg_placeholder = this.placeholder || this.msg_placeholder;
    this.btn_label = this.btnlab || "Upload";
    this.nocache_image_url(this.value, this.mime);
  },
  methods: {
    img_onerror: function(ev) {
      let vue = this;
      //console.warn("failed to load",this.cur_image_url,ev);
      vue.loaderror = true;
      this.$emit("loaderror");
    },
    select_file: function () {
      vue.image_error = "";
      vue.image_success = "";
    },
    upload_clear: function () {
      let vue = this;
      vue.loaderror = false;
      vue.$emit("input", "");
      vue.$emit("changed", "");
    },
    mime2type: function(mime) {
      if (!mime) { return; }
      let m;
      if (mime.match(/^video/)) {
        return "video";
      } else if (mime.match(/^audio/)) {
        return "audio";
      } else if (mime.match(/^image/)) {
        return "image";
      } else if (mime.match(/^text/)) {
        return "text";
      } else if (mime.match(/^application\/octet-stream/)) {
        return "binary";
      } else if ((m = mime.match(/^application\/(.+)/))) {
        return m[1];
      }
      return (mime.split("/")[0] || "unknown");
    },
    nocache_image_url: function(url,mime) {
      let vue = this;
      //console.log("nocache_image_url:"+url+" "+mime);
      mime = mime || "image/";
      if (!url) {
        vue.cur_image_url = "";
        vue.cur_image_mime = "";
      } else {
        if (url.indexOf("?") >= 0) {
          vue.cur_image_url = url+"&vxrnd="+Date.now();
        } else {
          vue.cur_image_url = url+"?vxrnd="+Date.now();
        }
        vue.cur_image_type = vue.mime2type(mime);
      }
      //console.log("nocache_image_url:"+vue.cur_image_type);
    },
    get_upload_url: function(ic,filename,cb) {
      let vue = this;

      if (!vue.evid && vue.imgkind) {
        window.wss_send_cb(vx, "get_storage", {
          cfg: {
             kind: vue.imgkind,
             "content-type": ic["content-type"],
             filename: filename,
          }
        }, function(msg) {
          if (!msg || !msg.data) {
            console.log("storage error");
            cb();
          } else if (msg.data.error || !msg.data.url) {
            console.log("storage error:"+msg.data.error);
            cb();
          } else {
            //console.dir(JSON.stringify(msg.data));
            cb({upload:{
                  url:msg.data.url,
                  hdrs:msg.data.hdrs
                }});
          }
        });
      } else if (vue.tnkind) {
         vx_api.createMyTn(window.vx, {
             kind:vue.tnkind
         }).then(stream => {
           if (stream && stream.upload && stream.upload.vxshare) {
             stream.upload.url = stream.upload.vxshare;
             stream.upload.hdrs = [["x-amz-acl","public-read"]];
           }
           cb(stream);
         }).catch(e => {
           cb();
         });
      } else if (vue.evid && vue.imgkind) {
          vx_api.createObj(window.vx, {
              evid: vue.evid,
              evpart: vue.imgkind,
            }).then((stream) => {
               if (stream && stream.upload && stream.upload.url) {
                 stream.upload.hdrs = [["x-amz-acl","public-read"]];
               }
               cb(stream);
            }).catch(e => {
               cb();
            });
      } else {
        cb();
      }
    },
    upload_image: function () {
      let vue = this;
      vue.image_error = "";
      vue.image_success = "";
      vue.loaderror = false;
      if (!vue.imageFile) {
        return;
      }
      if (vue.tnkind) {
      } else if (vue.evid) {
        if (!vue.imgkind) {
          vue.image_error = "Image kind property is required.";
          return;
        }
        if (!vue.evid) {
          vue.image_error = "Event id is required.";
          return;
        }
      } else if (vue.imgkind) {
      } else {
        vue.image_error = "Missing tnkind or imgkind/evid.";
        return;
      }
      let mime = (this.imageFile.type || "application/octet-stream");
      let filename = this.imageFile.name;
      let ftype = vue.mime2type(mime);
      let allowed = ["image"];
      let allow_all = false;
      if (vue.types) {
         if (vue.types != "*") {
            allowed = vue.types.split(",");
         } else {
            allow_all = true;
         }
      }
      if (!allow_all && (!ftype || !allowed.includes(ftype))) {
         vue.image_error = "Only "+allowed.join(",")+" files can be used.";
         return;
      }
      if (this.imageFile.size / 1024 / 1024 > (vue.size || 2)) {
         vue.image_error = `${ftype} size should be less than ${vue.size || 2} MB`;
         return;
      }

      let reader = new FileReader();
      reader.onload = function (e) {
        let img = e.target.result;
        let ic = {"content-type": mime};
        vue.imageUploadDisabled = true;
        try {
          vue.get_upload_url(ic,filename,function(stream) {
            if (stream && stream.upload && stream.upload.url) {
              let url = stream.upload.url;
              if (stream.upload.hdrs) {
                 stream.upload.hdrs.push(["cache-control","max-age=3600"]);
              }
              vue.image_success = `Uploading ${ftype} file ...`;
              window.issue_http({
                type: "PUT",
                nocred:true,
                url: url,
                contentType: mime,
                headers: stream.upload.hdrs,
                data: img,
                done: function (status, data) {
                  let dlurl =  url.split("?")[0];
                  console.log("Uploaded to " + dlurl,status);
                  if (status >= 200 && status < 300) {
                    vue.$emit("input", dlurl);
                    //if (dlurl != vue.orig_url) {
                      vue.$emit("changed", dlurl, mime, ftype);
                      vue.orig_url = dlurl;
                    //}
                    vue.image_success = `Successfully uploaded the ${ftype}.`;
                    vue.imageUploadDisabled = false;
                    vue.imageFile = null;
                    vue.nocache_image_url(dlurl, mime);
                  } else {
                    vue.image_success = "";
                    vue.imageUploadDisabled = false;
                    vue.image_error = `Upload failed for ${ftype}.`;
                  }
                }
              });
            } else {
              vue.image_success = "";
              vue.imageUploadDisabled = false;
              vue.image_error = "Unable to get upload URL.";
            }
          });
        } catch (e) {
          vue.image_success = "";
          vue.imageUploadDisabled = false;
          vue.image_error = `Upload failed for ${ftype}.`;
          console.warn(e);
        }
      };
      reader.onerror = function (e) {
        vue.imageUploadDisabled = false;
        vue.image_error = "Unable to read image file.";
      };
      reader.readAsArrayBuffer(vue.imageFile);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload_tn {
  max-height: 5rem;
}

.upload_file {
}

.upload_btn {
 margin: 0.1rem;
 padding: 0 0.25rem;
}

.upload_error {
  color: red;
  font-size: 0.8rem;
}
</style>